import { ReactElement, useState } from 'react';
import { NumberFormatBase } from 'react-number-format';
import Select from 'react-select';
import globalEnum from '../../enums/globalEnum';
import tools from '../../utils/tools';
import category from '../Category';

const ProductAccess = ({ products, form, setForm, cars, categories, brands }) => {
  const [query, setQuery] = useState('');

  const list = () => {
    const rows: ReactElement[] = [];

    products.filter(e => (e.title.toLowerCase().includes(query.toLowerCase()) || e.sku.toLowerCase().includes(query.toLowerCase()))).map((e, index) => {
      let key = form.products?.findIndex(j => e.id == j.productId);

      rows.push(
        <tr>
          <td>
            <Select options={tools.selectFormatter(Object.entries(globalEnum.unitType).map(([key, value]) => ({ value: key, label: value  })), 'value', 'label')} value={{ value: key >= 0 ? form.products[key]?.unitType : e.unitType, label: globalEnum.unitType[key >= 0 ? form.products[key]?.unitType : e.unitType]}} onChange={(selected) => setForm(prev => {
              const cp = {...prev};
              if (key < 0 || key == undefined){
                cp.products.push({ productId: e.id });
                key = cp.products.length - 1;
              }

              cp.products[key].unitType = selected.value;

              return cp;
            })}/>
          </td>
          <td>
            <Select options={[{ value: 0, label: 'غیرفعال' }, { value: 1, label: 'فعال' }]} value={{ value: (key >= 0) ? form.products[key]?.status : 1, label: (key >= 0 ? form.products[key]?.status : 1) == 1 ? 'فعال' : 'غیرفعال' }} onChange={(selected) => setForm(prev => {
              const cp = {...prev};

              if (key < 0 || key == undefined){
                cp.products.push({ productId: e.id });
                key = cp.products.length - 1;
              }

              cp.products[key].status = selected.value;

              return cp;
            })}/>
          </td>
          <td>
            <NumberFormatBase placeholder={e.price ? tools.formatPrice(e.price) : ''} className='addInput normalInput' value={key >= 0 ? form.products[key]?.price : e.price} onValueChange={(values) => setForm(prev => {
              const cp = {...prev};
              if (key < 0 || key == undefined){
                cp.products.push({ productId: e.id });
                key = cp.products.length - 1;
              }

              cp.products[key].price = values.value;

              return cp;
            })} format={(str) => (str ? tools.formatPrice(Number(str)) : '')} />
          </td>
          <td>
            {e.title + ' - (' + e.sku + ')'}
          </td>
          <td>
            <input
              type="checkbox"
              checked={!!(key >= 0 ? form.products[key]?.allowUnitTypeFallback : false)}
              onChange={(input) => setForm(prev => {
                const cp = {...prev};
                if (key < 0 || key == undefined){
                  cp.products.push({ productId: e.id });
                  key = cp.products.length - 1;
                }

                cp.products[key].allowUnitTypeFallback = input.target.checked;

                return cp;
              })}
            />
          </td>
          <td>
            {++index}
          </td>
        </tr>
      )});

    return rows;
  };

  const categoryList = () => {
    const rows: ReactElement[] = []

    categories.map((e, index) => {
      let key = form.categories?.findIndex(j => e.id == j.categoryId);
      rows.push(
        <tr>
          <td>
            <Select options={[{ value: 0, label: 'غیرفعال' }, { value: 1, label: 'فعال' }]} value={{ value: (key >= 0) ? form.categories[key]?.status : 1, label: (key >= 0 ? form.categories[key]?.status : 1) == 1 ? 'فعال' : 'غیرفعال' }} onChange={(selected) => setForm(prev => {
              const cp = {...prev};
              cp.categories[key].status = selected.value;

              cp.products = products.map(j => ({ productId: j.id, status: cp.categories.filter(k => k.status == 1).map(k => k.categoryId).includes(j.categoryId), price: j.price, unitType: j.unitType }))

              return cp;
            })}/>
          </td>
          <td>
            <NumberFormatBase placeholder={e.price ? tools.formatPrice(e.price) : ''} className='addInput normalInput' value={key >= 0 ? form.categories[key]?.price : e.price} onValueChange={(values) => setForm(prev => {
              const cp = {...prev};
              if (key < 0 || key == undefined){
                cp.categories.push({ categoryId: e.id });
                key = cp.categories.length - 1;
              }

              cp.categories[key].price = values.value;

              return cp;
            })} format={(str) => (str ? tools.formatPrice(Number(str)) : '')} />
          </td>
          <td>
            {e.title}
          </td>
          <td>
            {++index}
          </td>
        </tr>
      )});

    return rows;
  };
  return (
    <section className="accessTableSection">
      <h3>دسترسی ها</h3>
      <label className="sideBarTitle" htmlFor="infoTitle">ماشین ها</label>
      <Select options={tools.selectFormatter([{id: Number.MAX_SAFE_INTEGER, slug: 'انتخاب همه'},...cars], 'id', 'slug', 'بدون ماشین')} isMulti value={tools.selectFormatter(cars.filter(e => form?.selectedCars?.includes(e.id.toString())), 'id', 'title')} className="width100" id="infoTitle" onChange={(selected: any) => {
        setForm(prevState => {
          const cp = { ...prevState };
          // cp.products = products.map(e => ({ productId: e.id, status: selected.map(e => e.value).includes(e.cars?.map(e => e.id)), price: e.price, unitType: 'roll' }))
          cp.selectedCars = selected.map(e => e.value.toString()).includes(Number.MAX_SAFE_INTEGER.toString()) ? cars.map(e => e.id.toString()) : selected.map(e => e.value.toString());
          return cp
        })
      }}/>
      <label className="sideBarTitle" htmlFor="infoTitle">برند ها</label>
      <Select options={tools.selectFormatter([{id: Number.MAX_SAFE_INTEGER, title: 'انتخاب همه'},...brands], 'id', 'title', 'بدون برند')} isMulti value={tools.selectFormatter(brands.filter(e => form?.selectedBrands?.includes(e.id.toString())), 'id', 'title')} className="width100" id="infoTitle" onChange={(selected: any) => {
        setForm(prevState => {
          const cp = { ...prevState };
          cp.products = products.map(e => ({ productId: e.id, status: selected.map(e => e.value.toString()).includes(Number.MAX_SAFE_INTEGER.toString()) || selected.map(e => e.value.toString()).includes(e.brandId.toString()), price: e.price, unitType: e.unitType }))
          cp.selectedBrands = selected.map(e => e.value.toString()).includes(Number.MAX_SAFE_INTEGER.toString()) ? brands.map(e => e.id.toString()) : selected.map(e => e.value.toString())
          return cp
        });
      }}/>
      <table className="accessTable">
        <thead>
        <tr>
          <th>وضعیت</th>
          <th>قیمت</th>
          <th>دسته بندی</th>
          <th>ردیف</th>
        </tr>
        </thead>
        <tbody>
        {categoryList()}
        </tbody>
      </table>

      <label className="sideBarTitle" htmlFor="infoTitle">پیش فرض واحد فروش</label>
      <Select options={tools.selectFormatter(Object.entries(globalEnum.unitType).map(([key, value]) => ({ value: key, label: value  })), 'value', 'label')} onChange={(selected) => setForm(prev => {
        const cp = { ...prev };

        Object.entries(cp.products).map(([key, value]) => {
          cp.products[key].unitType = selected.value;
        })

        return cp;
      })}/>
      <label className="sideBarTitle">جستجو محصول</label>
      <input className="dashSearchInput" placeholder="جستجو بر اساس نام یا SKU..." value={query} onChange={(input) => setQuery(input.target.value)} />
      <table className="accessTable">
        <thead>
        <tr>
          <th>واحد فروش</th>
          <th>وضعیت</th>
          <th>قیمت</th>
          <th>محصول</th>
          <th>جایگزینی در صورت نبود موجودی</th>
          <th>ردیف</th>
        </tr>
        </thead>
        <tbody>
        {list()}
        </tbody>
      </table>
    </section>
  );
};

export default ProductAccess;